import { styled } from '@mui/material/styles';
import { Box, Grid, Paper, Typography } from '@mui/material';

// ─── Page shell ───────────────────────────────────────────────────────────────

export const PageWrapperStyled = styled('div', {
  name: 'FUC_PageWrapper',
})(({ theme }) => ({
  padding: theme.spacing(2, 0, 4),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2.5),
}));

// ─── Form bar ────────────────────────────────────────────────────────────────

export const GridStyled = styled(Grid, {
  name: 'FUC_FormBar',
})(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  boxShadow: 'none',
}));

// ─── Preview grid ─────────────────────────────────────────────────────────────

export const PreviewGridStyled = styled('div', {
  name: 'FUC_PreviewGrid',
})(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: theme.spacing(2.5),
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

// ─── Info card ────────────────────────────────────────────────────────────────

export const InfoCardStyled = styled(Paper, {
  name: 'FUC_InfoCard',
})(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
  boxShadow: 'none',
}));

export const CardHeaderBandStyled = styled(Box, {
  name: 'FUC_CardHeaderBand',
})<{ bandcolor: string }>(({ bandcolor }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  padding: '10px 16px',
  backgroundColor: `${bandcolor}12`,
  borderBottom: `1px solid ${bandcolor}28`,
}));

export const CardIconCircleStyled = styled(Box, {
  name: 'FUC_CardIconCircle',
})<{ bandcolor: string }>(({ bandcolor }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 36,
  height: 36,
  borderRadius: '50%',
  backgroundColor: `${bandcolor}20`,
  color: bandcolor,
  fontSize: '0.9rem',
  flexShrink: 0,
}));

export const CardBodyStyled = styled(Box, {
  name: 'FUC_CardBody',
})(() => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
}));

// ─── Count row ────────────────────────────────────────────────────────────────

export const CountRowStyled = styled(Box, {
  name: 'FUC_CountRow',
})(({ theme }) => ({
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'space-between',
  padding: theme.spacing(1.25, 2),
  borderBottom: `1px solid ${theme.palette.divider}`,
  '&:last-child': {
    borderBottom: 'none',
  },
}));

export const CountLabelStyled = styled(Typography, {
  name: 'FUC_CountLabel',
})(({ theme }) => ({
  fontSize: '0.82rem',
  color: theme.palette.text.secondary,
}));

export const CountValueStyled = styled(Typography, {
  name: 'FUC_CountValue',
})<{ accent: string }>(({ accent }) => ({
  fontSize: '1.1rem',
  fontWeight: 700,
  color: accent,
  minWidth: 32,
  textAlign: 'right',
}));

// ─── Confirmation panel ───────────────────────────────────────────────────────

export const ConfirmPanelStyled = styled(Paper, {
  name: 'FUC_ConfirmPanel',
})(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  padding: theme.spacing(2, 2.5),
  border: `1px solid #DF707045`,
  borderRadius: theme.shape.borderRadius,
  boxShadow: 'none',
  backgroundColor: '#DF707008',
}));

// ─── File list (inside File Data card) ────────────────────────────────────────

export const FileListWrapperStyled = styled(Box, {
  name: 'FUC_FileListWrapper',
})(({ theme }) => ({
  maxHeight: 220,
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
}));

export const FileRowStyled = styled(Box, {
  name: 'FUC_FileRow',
})(({ theme }) => ({
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
  padding: theme.spacing(1, 2),
  borderBottom: `1px solid ${theme.palette.divider}`,
  '&:last-child': {
    borderBottom: 'none',
  },
}));

export const FileNameStyled = styled(Typography, {
  name: 'FUC_FileName',
})(({ theme }) => ({
  fontSize: '0.82rem',
  fontWeight: 600,
  color: theme.palette.text.primary,
  wordBreak: 'break-all',
}));

export const FileUploadedAtStyled = styled(Typography, {
  name: 'FUC_FileUploadedAt',
})(({ theme }) => ({
  fontSize: '0.75rem',
  color: theme.palette.text.secondary,
  whiteSpace: 'nowrap',
  flexShrink: 0,
}));
